// V.1.0.0 (2026-02-16)
// --- START OF FILE apps/reseye-web/src/components/NotificationToast.jsx ---
import React, { useEffect, useState } from 'react';
import '../styles/NotificationToast.css';

const NotificationToast = ({ notification, onClear, t }) => {
    if (!notification) return null;

    return (
        <div className="notification-toast visible">
            <div className="toast-indicator-container">
                <div className="led-indicator"></div>
            </div>
            <div className="toast-content">
                <h4 className="toast-title">{notification.title || t('alertTitle', 'ALERTA')}</h4>
                <p className="toast-message">{notification.body}</p>
                <small className="toast-instruction">
                    {t('silenceInstruction', 'Cerrar para silenciar')}
                </small>
            </div>
            <button className="toast-close" onClick={onClear} aria-label={t('close', 'Cerrar')}>
                ✕
            </button>
        </div>
    );
};

export default NotificationToast;
// --- END OF FILE apps/reseye-web/src/components/NotificationToast.jsx ---
